import { RequestState } from '../../../shared/definitions/request-state.enum';
import { SimXTaxonomyTerm } from '../../../shared/models/entities/simx-taxonomy-term.model';

export interface State {
  taxonomyTermsRequestState: RequestState;
  taxonomyTerms: Array<SimXTaxonomyTerm>;
}

export const initialState: State = {
  taxonomyTermsRequestState: RequestState.Initial,
  taxonomyTerms: [],
};
